/**
 * Oturumun ne zaman biteceği — tek kaynak (03.11.2026).
 *
 * Sunucu her yanıta X-Oturum-Kalan (sn) ve X-Oturum-Tur (bosta: hareketsizlik | sure: 24 saat) ekler
 * (backend services/oturum.py); utils/apiAuth.js bunları buraya yazar. Bitiş zamanı localStorage'da durur:
 * bir sekmede yapılan işlem diğer sekmelerdeki sayacı da hemen günceller ('storage' olayı).
 *
 * Oturum sunucuda bittiğinde (401 + WWW-Authenticate) `bitir(mesaj)` çağrılır: mesaj giriş ekranında gösterilmek
 * üzere sessionStorage'a yazılır ve 'oturum-bitti' olayı yayınlanır (AuthContext dinler, çıkış yapar).
 */
const BITIS = 'oturum_bitis';
const TUR = 'oturum_tur';
export const MESAJ_ANAHTARI = 'oturum_mesaji';

const dinleyiciler = new Set();
const bildir = () => dinleyiciler.forEach((fn) => { try { fn(); } catch (e) { /* dinleyici hatası yayılmasın */ } });

const oku = (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } };
const yaz = (k, v) => { try { localStorage.setItem(k, v); } catch (e) { /* özel pencere */ } };
const sil = (k) => { try { localStorage.removeItem(k); } catch (e) { /* özel pencere */ } };

export const guncelle = (kalanSn, tur) => {
  const sn = Number(kalanSn);
  if (!Number.isFinite(sn) || sn < 0) return;
  yaz(BITIS, String(Date.now() + sn * 1000));
  yaz(TUR, tur === 'sure' ? 'sure' : 'bosta');
  bildir();
};

export const durum = () => ({
  bitis: Number(oku(BITIS)) || 0,
  tur: oku(TUR) === 'sure' ? 'sure' : 'bosta',
});

export const temizle = () => {
  sil(BITIS);
  sil(TUR);
  bildir();
};

export const bitir = (mesaj) => {
  try {
    sessionStorage.setItem(MESAJ_ANAHTARI, mesaj || 'Oturumunuz sonlandı. Lütfen yeniden giriş yapın.');
  } catch (e) { /* özel pencere */ }
  temizle();
  window.dispatchEvent(new CustomEvent('oturum-bitti', { detail: mesaj }));
};

/** Giriş ekranında gösterilecek mesajı bir kez okur. */
export const mesajiAl = () => {
  try {
    const m = sessionStorage.getItem(MESAJ_ANAHTARI);
    sessionStorage.removeItem(MESAJ_ANAHTARI);
    return m;
  } catch (e) {
    return null;
  }
};

export const abone = (fn) => {
  dinleyiciler.add(fn);
  const depo = (e) => { if (e.key === BITIS || e.key === TUR) fn(); };
  window.addEventListener('storage', depo);
  return () => {
    dinleyiciler.delete(fn);
    window.removeEventListener('storage', depo);
  };
};

const oturumSaati = { guncelle, durum, temizle, bitir, mesajiAl, abone, MESAJ_ANAHTARI };
export default oturumSaati;
